module.exports = __webpack_public_path__ + "media/index/find-scholarships-to-pay-for-college-with-fastweb-47496b29.jpg";